import './../reaction-lists/reaction-lists.scss';
import api from 'api';
import moment from 'moment';
import { ReactionListsType, WordBinGroupType } from 'types';
import { useCallback, useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router'
import NewCrisisListModal from './new-crisis-list-modal';

function CrisisMontoringLists() {
    const params: any = useParams();
    const history = useHistory();
    const [crisiMontoringLists, setCrisiMontoringLists] = useState<ReactionListsType[]>([]);
    const [wordBinGroups, setWordBinGroups] = useState<WordBinGroupType[]>([]);
    const [newCrisisListModalOpen, setNewCrisisListModalOpen] = useState<boolean>(false);

    const getCrisiMontoringLists = useCallback(() => {
        api.reactionLists.getAll(params.clientId).then(data => {
            setCrisiMontoringLists(data.filter((x: ReactionListsType) =>
                x.WordBinTypeId === 2
            ));
        })
    }, [params.clientId])

    const getWordBinGroups = useCallback(() => {
        api.reactionLists.getWordBinGroups(params.clientId).then(data => {
            setWordBinGroups(data);
        })
    }, [params.clientId])

    const goToCrisiMontoringList = (reactionListId: number) => {
        history.push(`/client/${params.clientId}/reaction-list/crisis/` + reactionListId);
    }

    useEffect(() => {
        getCrisiMontoringLists();
        getWordBinGroups();
    }, [getCrisiMontoringLists, getWordBinGroups]);

    return (
        <>
            <div className="reaction-list">
                <p>Crisis Monitoring Word Bins
                    <span id="group-name"></span>
                    <i
                        className="far fa-plus"
                        onClick={() => setNewCrisisListModalOpen(true)}>
                    </i>
                </p>

                <div className="flex-container">
                    <div id="groups">
                        <p>
                            <i className="fal fa-folders"></i>
                            <span onClick={() => { }}>Groups</span>
                            <i className="fal fa-plus" onClick={() => { }}></i>
                        </p>
                        <ul id="group-list">
                            {!wordBinGroups.length ? (
                                <></>
                            ) : (
                                wordBinGroups.map(x => (
                                    <li><i className="fal fa-folder"></i>Test <i className="far fa-plus"></i><i className="far fa-trash"></i></li>
                                ))
                            )}
                        </ul>
                    </div>

                    <div id="table">
                        <table>
                            <thead>
                                <tr>
                                    <th className="text-bold">Name</th>
                                    <th className="text-bold">Type</th>
                                    <th className="text-center text-bold">Interval</th>
                                    <th className="text-bold">Start Date</th>
                                    <th className="text-bold">End Date</th>
                                    <th className="text-bold">Last Sent</th>
                                    <th className="text-center text-bold">Keywords</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody id="list">
                                {!crisiMontoringLists.length ? (
                                    <tr>
                                        <td colSpan={9} className="text-center">
                                            <i>No crisis bins created.
                                            </i>
                                        </td>
                                    </tr>
                                ) : (
                                    crisiMontoringLists.filter(x => x.ProjectId === parseInt(params.projectId)).map(x => (
                                        <tr onClick={() => goToCrisiMontoringList(x.Id)}>
                                            <td>{x.Description}</td>
                                            <td><span>Word Bin</span></td>
                                            <td className="text-center">{x.NotificationInterval}</td>
                                            <td>{moment(x.StartDate).format("DD MMM YYYY")}</td>
                                            <td>{moment(x.StopDate).format("DD MMM YYYY")}</td>
                                            <td>{moment(x.DateLastSent).format("DD MMM YYYY HH:mm")}</td>
                                            <td className="text-center">{x.Keywords.length}</td>
                                            <td><i className="fal fa-pencil"></i></td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <NewCrisisListModal onSave={getCrisiMontoringLists} open={newCrisisListModalOpen} setOpen={setNewCrisisListModalOpen} />
        </>
    )
}

export default CrisisMontoringLists;